// extracted by mini-css-extract-plugin
export default {"section":"styles_section__jRVeX","title":"styles_title__tBJI0","list":"styles_list__03nTp","row":"styles_row__tpMR6","tick":"styles_tick__1YYSI","rowText":"styles_rowText__6MJ-D"};